import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';

/**
 * AOS 공통 기능 on/off 제어 컴포넌트
 */
const AOSControl = () => {
  const { themeConfig, set } = useTheme();
  const currentThemeConfig = themeConfig || {};

  return (
    <div style={{ marginTop: '15px', marginBottom: '15px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
        <label style={{ fontSize: '12px', fontWeight: 600, color: '#333' }}>✨ AOS 공통 기능:</label>
        <label
          style={{
            position: 'relative',
            display: 'inline-block',
            width: '50px',
            height: '24px',
            cursor: 'pointer'
          }}
        >
          <input
            type="checkbox"
            checked={currentThemeConfig.aosEnabled !== false}
            onChange={(e) => {
              set('aosEnabled', e.target.checked);
              // 즉시 AOS 상태 반영 (AOS가 로드되어 있고 메서드가 존재할 때만)
              if (typeof window.AOS !== 'undefined' && window.AOS) {
                try {
                  if (e.target.checked) {
                    // AOS 활성화
                    if (typeof window.AOS.enable === 'function') {
                      window.AOS.enable();
                    }
                    // AOS 새로고침
                    if (typeof window.AOS.refreshHard === 'function') {
                      window.AOS.refreshHard();
                    } else if (typeof window.AOS.refresh === 'function') {
                      window.AOS.refresh();
                    }
                  } else {
                    // AOS 비활성화
                    try {
                      // 1. disable 메서드가 있으면 사용
                      if (typeof window.AOS.disable === 'function') {
                        window.AOS.disable();
                      }

                      // 2. 모든 AOS 요소에서 완전히 제거
                      const aosElements = document.querySelectorAll('[data-aos]');
                      aosElements.forEach(el => {
                        el.removeAttribute('data-aos');
                        el.classList.remove('aos-init', 'aos-animate');
                        // 인라인 스타일도 제거
                        el.style.transform = '';
                        el.style.opacity = '';
                        el.style.transition = '';
                      });

                      // 3. AOS를 완전히 비활성화된 상태로 재초기화
                      if (window.__AOS_INITIALIZED__) {
                        window.__AOS_INITIALIZED__ = false;
                        window.AOS.init({
                          disable: true, // 완전히 비활성화
                        });
                        window.__AOS_INITIALIZED__ = true;
                      }
                    } catch (error) {
                      console.warn('AOS 비활성화 실패:', error);
                    }
                  }
                } catch (error) {
                  console.warn('AOS 상태 변경 실패:', error);
                }
              }
            }}
            style={{
              opacity: 0,
              width: 0,
              height: 0
            }}
          />
          <span
            style={{
              position: 'absolute',
              cursor: 'pointer',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: currentThemeConfig.aosEnabled !== false ? (currentThemeConfig.themeColor || '#e97730') : '#ccc',
              transition: '0.3s',
              borderRadius: '24px'
            }}
          >
            <span
              style={{
                position: 'absolute',
                content: '""',
                height: '18px',
                width: '18px',
                left: '3px',
                bottom: '3px',
                backgroundColor: 'white',
                transition: '0.3s',
                borderRadius: '50%',
                transform: currentThemeConfig.aosEnabled !== false ? 'translateX(26px)' : 'translateX(0)'
              }}
            />
          </span>
        </label>
      </div>
      <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
        {currentThemeConfig.aosEnabled !== false ? '활성화됨' : '비활성화됨'} - 업무화면 스크롤 애니메이션 제어
      </div>
    </div>
  );
};

export default AOSControl;
